import pick from 'lodash/pick';
import { http } from './http';
import { SurveyPostData, TemporaryAnswers } from '@surveycake/logic-engine';

interface AnsObj {
	svid: string;
	tempAnswers: TemporaryAnswers;
}

interface GetTempAnswersResponse {
	ansobj: AnsObj;
}

export async function getTempAnswers(
	surveyHash: string,
	tempAnswerHash: string,
): Promise<GetTempAnswersResponse> {
  try {
    const url = http.url.api(
      `/s/ans/temp/get?${http.query({
        svid: surveyHash,
        temporary_answer_hash: tempAnswerHash,
      })}`,
      2,
    );
		const res = await http.get(url);
		const { data } = await http.handleResponse(res);

		return data;
  } catch (error) {
    throw error;
  }
};

export async function storeTempAnswers(
	tempAnswers: TemporaryAnswers,
	postData: SurveyPostData,
) {
	try {
		const { ansobj } = postData;

		const body = JSON.stringify({
			ansobj: {
				...pick(ansobj, ['svid']),
				tempAnswers,
			},
		});

    const headers = {
			'content-type': 'application/json',
			'accept': 'application/json',
    };
		const url = http.url.api(
			`/s/ans/temp/store`,
			2,
		);

		const response = await http.post(url, {
			body,
			headers,
		});

		const { status, data } = await http.handleResponse(response);
		const { temporary_answer_hash } = data;

		if (!status) {
      throw status;
    }

		return temporary_answer_hash;
	} catch (error) {
		throw error;
	}
};

export async function deleteTempAnswer(
	surveyHash: string,
	tempAnswerHash: string,
	callback: () => void,
) {
	try {
		const data = {
			svid: surveyHash,
			temporary_answer_hash: tempAnswerHash,
		};
		const body = JSON.stringify(data);
    const headers = {
      'content-type': 'application/json'
    };
		const url = http.url.api(
			`/s/ans/temp/del`,
			2,
		);

		const response = await http.delete(url, {
			body,
			headers,
		});
		await http.handleResponse(response);
		callback();
	} catch (error) {
		callback();
		throw error;
	}
};
